var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.2568,
    r: 15.04,
    fill: "#58CC02",
    stroke: "white",
    strokeWidth: 1.92
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 16.4731L12.1365 19.4318C12.9108 20.2491 14.2067 20.2666 15.0027 19.4706L22.2164 12.2568",
    stroke: "white",
    strokeWidth: 4.66667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.129b4619beb55eb997735c8b0f056d91.svg";
export { ForwardRef as ReactComponent };